/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/CancelSubscription/theme';

export const CancelSubscriptionTheme = theme;
